// 判断是否是微信客户端
export const isWxClient = () => {
  var ua = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) === 'micromessenger'
}

export const setLocalStore = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}

export const getLocalStore = (name) => {
  return JSON.parse(localStorage.getItem(name) || '{}')
}

export const removeLocalStore = (name) => {
  localStorage.removeItem(name)
}
